import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BillingStore } from '@app/interfaces/billing-store.interface';
import { PolicyData } from '@app/interfaces/policy.interface';
import { BillingInfoService } from '@shared/services/billing-info.service';
import { PayerInfoService } from '../payer-info/payer-info.service';
import { BillingStoreService } from '../store/billing-store.service';
import { AptFeatureFlagService } from '@archinsurance-da/arch-portal-tools';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  standalone: false,
})
export class SuccessComponent implements OnInit {
  downloading: boolean = false;
  cyberOfferEnabled: boolean = false;
  policyVerified: boolean = false;
  isProgressiveFlow: boolean = false;
  isCyberFlow: boolean = false;

  constructor(
    private router: Router,
    private payerInfoService: PayerInfoService,
    private billingStoreService: BillingStoreService,
    private ffService: AptFeatureFlagService,
    private billingInfoService: BillingInfoService
  ) {}

  successPayData: any;
  policyStore: BillingStore = {};
  //redirectGuid: string;

  ngOnInit(): void {
    this.successPayData = JSON.parse(sessionStorage.getItem('successPayData'));
    this.policyStore = this.billingStoreService.getBillingStore();

    this.isCyberFlow = this.billingStoreService.isCyberFlow();

    this.ffService.flagChange.subscribe((flags: any) => {
      const cyberOfferEnabled = !flags.cyberOfferEnabledAgent?.current
        ? flags.cyberOfferEnabledAgent
        : flags.cyberOfferEnabledAgent.current;
      // console.log('flags', flags);
      this.cyberOfferEnabled = cyberOfferEnabled;
    });

    //this.redirectGuid = atob(this.policyStore?.policyData?.policy?.policyId);
    const producer =
      this.policyStore?.policyData?.policy?.agentCd || this.getProducerFromProduct(this.policyStore?.product);

    if (producer === '44681') {
      this.isProgressiveFlow = true;
    } else if (producer === '43274') {
      this.isProgressiveFlow = false;
    } else if (producer === '43580') {
      this.isProgressiveFlow = false;
    } else if (producer === '18089') {
      this.isProgressiveFlow = false;
    }

    if (this.policyStore.policyData.policy.quoteStatus !== 'ISS') {
      //if policy is not issued, try updating the policy before throwing them out
      this.billingInfoService
        .getPolicy(this.policyStore.policyData.policy.policyId, this.policyStore.product)
        .subscribe((policyData: PolicyData) => {
          this.policyStore.policyData = policyData;
          // console.info(`%c Policy Number ${this.policyStore.policyData.policy.polNbr}`, 'font-weight: bold; color: #0057b8');
          this.billingStoreService.setBillingStore(this.policyStore);
          this.policyVerified = true;
        });
    } else {
      this.policyVerified = true;
    }

    // console.log('this.successPayData', this.successPayData);
  }
  goBackToBQX() {
    if (this.policyStore.redirectUrl && this.payerInfoService.validateUrl(atob(this.policyStore.redirectUrl))) {
      window.location.href = atob(this.policyStore.redirectUrl);
    }
  }

  goToPolicy() {
    this.router.navigate(['policy', this.policyStore.policyData.policy.policyId]);
  }
  private getProducerFromProduct(product: string): string {
    // Map product type to producer ID
    if (product === 'ea') {
      return 'P43580'; // Canopy
    }
    return 'P43274'; // Default to Nationwide
  }

  downloadPolicy() {
    if (!this.downloading) {
      this.downloading = true;
      this.payerInfoService.downloadPolicy(this.policyStore).subscribe((resultBytes) => {
        var blob = new Blob([resultBytes], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `arch-policy-${this.policyStore.policyData.policy.policyId}.pdf`;
        link.click();

        this.downloading = false;
      });
    }
  }

  navigateToCyber() {
    const cyberAccess = {
      policyId: this.policyStore?.policyData?.policy?.policyId,
      timestamp: new Date().toISOString(),
      fromSuccessPage: true,
    };
    sessionStorage.setItem('cyberAccess', JSON.stringify(cyberAccess));

    this.router.navigate(['/cyber', this.policyStore?.policyData?.policy?.policyId]);
  }
}
